import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Board } from './Board'

export const ListOfBoardValidation = z.object({
  list: z.instanceof(Board, { message: '[ListOfBoard] list is required' }).array(),
})

export class ListOfBoard extends Model {
  static create({ list }: z.infer<typeof ListOfBoardValidation>) {
    ListOfBoardValidation.parse({ list })
    return new ListOfBoard(list)
  }

  constructor(readonly list: Board[]) {
    super()
  }

  toJSON() {
    return { list: this.list.map(item => item.toJSON()) }
  }

  map<T>(callback: (board: Board, index: number) => T) {
    return this.list.map(callback)
  }

  at(index: number) {
    return this.list.at(index)
  }

  unique() {
    const seen = new Set<string>()
    const uniqueList = this.list.filter(board => {
      const { code } = board.toJSON()
      if (seen.has(code)) {
        return false
      }
      seen.add(code)
      return true
    })
    return ListOfBoard.create({ list: uniqueList })
  }
}
